module.exports = __webpack_public_path__ + "img/element-file_input.3a4ad1c.svg";